import FileImportService from './FileImportService';

// 获取单例实例
const fileImportService = FileImportService.getInstance();

// 直接绑定方法引用，保持 this 上下文
export const getFileRecords = fileImportService.getFileRecords.bind(fileImportService);
export const getUploadBenefits = fileImportService.getUploadBenefits.bind(fileImportService);
export const reset = fileImportService.reset.bind(fileImportService);
export const checkCanExit = fileImportService.checkCanExit.bind(fileImportService);
export const deleteRecord = fileImportService.deleteRecord.bind(fileImportService);
export const retry = fileImportService.retry.bind(fileImportService);
export const filesImport = fileImportService.filesImport.bind(fileImportService);

export * from './AudioImportService';
export * from './utils/AudioValidator';
